import { observer } from "mobx-react-lite";
import React from "react";

export const SelectFunboxText = observer(({ name }: { name: string }) => {
  return (
    <span>
      <span className={"sr-only"}>Select Funbox. Currently Selected:</span>
      {name}
    </span>
  );
});
